import gql from 'graphql-tag';

export const DELETE_PROJECT_MUTATION = gql`
  mutation DeleteProject($where: ProjectWhereUniqueInput!) {
    deleteProject(where: $where) {
      id
    }
  }
`;
